/* Marmini & Co. motion layer — scroll reveals, word rotator, magnetic buttons,
   cursor ring, parallax, count-ups. Everything respects prefers-reduced-motion. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------- scroll reveal ---------- */
  if (!reduced && 'IntersectionObserver' in window) {
    var slideSel = [
      '.marmini-kicker',
      '.marmini-hero__heading', '.marmini-hero__text', '.marmini-hero__rotator', '.marmini-hero__buttons',
      '.marmini-services__card', '.marmini-menu__card',
      '.marmini-about__text', '.marmini-about__button',
      '.marmini-stats__item',
      '.marmini-inquire__intro',
      'h2.h1'
    ].join(',');
    var fadeSel = [
      '.marmini-polaroid',
      '.marmini-testimonials__card',
      '.marmini-team__grid > div',
      '.marmini-hero__media',
      '.marmini-about__media'
    ].join(',');

    document.querySelectorAll(slideSel).forEach(function (el) { el.classList.add('mrv', 'mrv--slide'); });
    document.querySelectorAll(fadeSel).forEach(function (el) { el.classList.add('mrv', 'mrv--fade'); });

    document.querySelectorAll(
      '.marmini-bars__grid, .marmini-services__grid, .marmini-menu__grid, .marmini-team__grid, .marmini-testimonials__list, .marmini-stats__grid'
    ).forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--mrv-delay', (i * 90) + 'ms');
      });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mrv-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

    document.querySelectorAll('.mrv').forEach(function (el) { io.observe(el); });
  }

  /* ---------- rotating word ---------- */
  document.querySelectorAll('[data-marmini-rotate]').forEach(function (el) {
    var words;
    try { words = JSON.parse(el.getAttribute('data-marmini-rotate')); } catch (e) { return; }
    words = words.map(function (w) { return String(w).trim(); }).filter(Boolean);
    if (!words.length) return;
    var i = 0;
    el.textContent = words[0];
    if (reduced || words.length < 2) return;
    setInterval(function () {
      el.classList.add('is-flipping');
      setTimeout(function () {
        i = (i + 1) % words.length;
        el.textContent = words[i];
        el.classList.remove('is-flipping');
      }, 280);
    }, 2700);
  });

  /* ---------- magnetic buttons + cursor ring ---------- */
  if (!reduced && finePointer) {
    document.querySelectorAll('.button').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        btn.style.translate = (x * 8).toFixed(1) + 'px ' + (y * 6).toFixed(1) + 'px';
      });
      btn.addEventListener('mouseleave', function () { btn.style.translate = ''; });
    });

    var ring = document.createElement('div');
    ring.className = 'marmini-cursor';
    ring.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ring);
    var mx = window.innerWidth / 2, my = window.innerHeight / 2, rx = mx, ry = my;
    window.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; ring.classList.add('is-on'); }, { passive: true });
    document.addEventListener('mouseover', function (e) {
      ring.classList.toggle('is-big', !!(e.target.closest && e.target.closest('a, button, summary, label, input, select, textarea')));
    });
    (function loop() {
      rx += (mx - rx) * 0.16;
      ry += (my - ry) * 0.16;
      ring.style.transform = 'translate3d(' + rx.toFixed(1) + 'px,' + ry.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- parallax (ghost words + floaters) ---------- */
  if (!reduced) {
    var pxEls = Array.prototype.slice.call(document.querySelectorAll('.marmini-cta__ghost, .marmini-float'));
    if (pxEls.length) {
      var ticking = false;
      var update = function () {
        pxEls.forEach(function (el) {
          var speed = parseFloat(el.getAttribute('data-speed') || '0.12');
          var host = el.parentElement.getBoundingClientRect();
          var off = (host.top + host.height / 2 - window.innerHeight / 2) * speed;
          el.style.setProperty('--py', off.toFixed(1) + 'px');
        });
        ticking = false;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      update();
    }
  }

  /* ---------- count-up stats ---------- */
  var nums = document.querySelectorAll('[data-marmini-count]');
  if (nums.length && 'IntersectionObserver' in window) {
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-marmini-count'), 10) || 0;
        io2.unobserve(el);
        if (reduced) { el.textContent = target; return; }
        var dur = 1300, t0 = performance.now();
        (function step(t) {
          var p = Math.min(1, (t - t0) / dur);
          el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io2.observe(n); });
  }
})();

/* ============ $100k motion layer ============ */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------- scroll progress bar ---------- */
  var bar = document.createElement('div');
  bar.className = 'marmini-progress';
  document.body.appendChild(bar);

  /* ---------- native scroll (no hijack — trackpads hate it), rAF-driven accents ---------- */
  var velocity = 0;
  var marqueeTracks = document.querySelectorAll('.marmini-marquee__track');
  var lastY = window.scrollY;

  (function raf() {
    // progress bar
    var max = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';

    // velocity skew on marquees (from native scroll delta)
    if (!reduced) {
      velocity += ((window.scrollY - lastY) - velocity) * 0.12;
      lastY = window.scrollY;
      var skew = Math.max(-5, Math.min(5, velocity * 0.22));
      marqueeTracks.forEach(function (t) {
        t.style.transform = 'skewX(' + (-skew) + 'deg)';
      });
    }
    requestAnimationFrame(raf);
  })();

  /* ---------- cinematic media reveals + inner parallax ---------- */
  if (!reduced) {
    var frames = document.querySelectorAll('.marmini-hero__media .marmini-frame, .marmini-about__media .marmini-frame, .marmini-show__media .marmini-frame');
    frames.forEach(function (f) { f.classList.add('mwipe'); });
    // observe the UNCLIPPED parent — clip-path on the frame makes IO report 0 intersection
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var fr = en.target.querySelector('.mwipe');
          if (fr) fr.classList.add('mwipe-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    frames.forEach(function (f) { io.observe(f.parentElement); });

    // gentle parallax drift inside every framed image
    var pImgs = Array.prototype.map.call(frames, function (f) { return f.querySelector('img'); }).filter(Boolean);
    var pTick = false;
    function drift() {
      pImgs.forEach(function (img) {
        var r = img.closest('.marmini-frame').getBoundingClientRect();
        var p = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.setProperty('--drift', (p * -6).toFixed(2) + '%');
      });
      pTick = false;
    }
    window.addEventListener('scroll', function () {
      if (!pTick) { requestAnimationFrame(drift); pTick = true; }
    }, { passive: true });
    drift();
  }

  /* ---------- page transitions (curtain) ---------- */
  var curtain = document.createElement('div');
  curtain.className = 'marmini-curtain';
  curtain.innerHTML = '<div class="marmini-curtain__p marmini-curtain__p--olive"></div>' +
    '<div class="marmini-curtain__p marmini-curtain__p--ink">' +
    (window.MARMINI_CHAT && window.MARMINI_CHAT.mascot ? '<img src="' + window.MARMINI_CHAT.mascot + '" alt="" width="120" height="120">' : '') +
    '</div>';
  document.body.appendChild(curtain);

  // entrance: if we arrived via a transition, sweep curtains away
  if (!reduced && sessionStorage.getItem('marmini-transition')) {
    sessionStorage.removeItem('marmini-transition');
    curtain.classList.add('is-covering');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        curtain.classList.add('is-leaving');
        setTimeout(function () { curtain.classList.remove('is-covering', 'is-leaving'); }, 900);
      });
    });
  }

  // exit: intercept internal nav
  if (!reduced) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.hash) return;
      e.preventDefault();
      sessionStorage.setItem('marmini-transition', '1');
      curtain.classList.add('is-entering');
      setTimeout(function () { location.href = a.href; }, 620);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) curtain.classList.remove('is-entering', 'is-covering', 'is-leaving');
    });
  }
})();
